import { CurrencyPipe, DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { HorizontalListData, HorizontalListFactory, SimpleHorizontalListAppearanceType, SimpleHorizontalListBgColorType, SimpleHorizontalListTitleSize, SimpleHorizontalListWidgetConfigData } from "common";
import { AccountData, AutoPaymentMode, AutoPaymentModeMap } from "../account.model";
import { AccountService } from '../account.service';
import { AccountModificationDetailsComponentData } from "./account-modification-details.component";

@Injectable()
export class AccaountModificationDetailsAdapter {
  constructor(
    private readonly currencyPipe: CurrencyPipe,
    private readonly datePipe: DatePipe,
    private readonly accountService: AccountService,
  ) { }

  adaptModificationsListData = (data: AccountModificationDetailsComponentData): HorizontalListData[] => {
    const currentPaymentAmount = this.getOutstandingBalance(data?.account) ? data?.account?.currentState?.paymentAmount : 0;
    const currentPaymentDueDate = !data?.account?.noAutoPayments && this.getOutstandingBalance(data?.account) ? data?.accountInfo?.paymentDueDate : null;
    const modification = data?.account?.modification || null;

    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Current payment amount',
        displayedValue: this.formatCurrency(currentPaymentAmount),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Payment due date',
        displayedValue: this.formatDate(currentPaymentDueDate) || 'Not Due',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Updated on',
        displayedValue: this.formatDate(modification?.updatedOn) || '-',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Updated by',
        displayedValue: modification?.updatedBy?.FullName || '-',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Activated on',
        displayedValue: this.formatDate(modification?.activatedOn) || '-',
      })
    ]
  }

  adaptSummaryListData = (startDate: Date, endDate: Date, autoPaymentMode: AutoPaymentMode): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Start date',
        displayedValue: this.formatDate(startDate) || '-',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'End date',
        displayedValue: this.formatDate(endDate) || '-',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Auto-payment mode',
        displayedValue: this.getAutoPaymentMode(autoPaymentMode) || '-',
      }),
    ]
  }

  private formatCurrency(value: number): string {
    return this.currencyPipe.transform(value);
  }

  private formatDate(value: Date): string {
    return this.datePipe.transform(value);
  }

  private getOutstandingBalance(account: AccountData): number {
    return this.accountService.getOutstandingBalance(account);
  }

  private getAutoPaymentMode(autoPaymentMode: AutoPaymentMode): string {
    return AutoPaymentModeMap.get(autoPaymentMode);
  }

  adaptModificationsWidgetConfigData = (): SimpleHorizontalListWidgetConfigData => {
    return {
      backgroundColorType: SimpleHorizontalListBgColorType.Grey,
      cardAppearanceType: SimpleHorizontalListAppearanceType.Outlined,
      titleSize: SimpleHorizontalListTitleSize.Small
    }
  }
}
